"use client";

import {
  SkeletonBox,
  SkeletonContainer,
} from "@/components/ui/skeleton";

interface PendingBlockProps {
  withRepoList?: boolean;
}

function PendingBlock({ withRepoList = false }: PendingBlockProps) {
  return (
    <SkeletonContainer className="flex w-full min-w-0 flex-col gap-4">
      <div className="flex w-full min-w-0 items-start gap-3">
        <SkeletonBox className="size-10 shrink-0 rounded-md" />
        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <SkeletonBox className="h-4 w-32 rounded" />
          <SkeletonBox className="h-3 w-48 rounded" />
          <SkeletonBox className="h-3 w-24 rounded" />
        </div>
        <SkeletonBox className="size-4 rounded" />
      </div>
      {withRepoList && (
        <div className="flex flex-col gap-2 pl-1">
          <SkeletonBox className="h-3.5 w-24 rounded" />
          <SkeletonBox className="h-3 w-44 rounded" />
          <SkeletonBox className="h-3 w-40 rounded" />
          <SkeletonBox className="h-3 w-48 rounded" />
        </div>
      )}
    </SkeletonContainer>
  );
}

export interface TechnicalProfilePendingProps {
  showGithub: boolean;
  showStackOverflow: boolean;
}

export function TechnicalProfilePending({
  showGithub,
  showStackOverflow,
}: TechnicalProfilePendingProps) {
  return (
    <div className="flex w-full min-w-0 flex-col gap-5">
      {showStackOverflow && <PendingBlock />}
      {showStackOverflow && showGithub && (
        <div className="h-px w-full bg-border" />
      )}
      {showGithub && <PendingBlock withRepoList />}
    </div>
  );
}
